export const ARROW_DOWN = 'ArrowDown';
export const ARROW_LEFT = 'ArrowLeft';
export const ARROW_RIGHT = 'ArrowRight';
export const ARROW_UP = 'ArrowUp';
export const C = 'c';
export const COMMA = ',';
export const DELETE = 'Backspace';
export const ENTER = 'Enter';
export const ESCAPE = 'Escape';
export const SPACE = ' ';
export const NUMPAD_0 = '0';
export const NUMPAD_1 = '1';
export const NUMPAD_2 = '2';
export const NUMPAD_3 = '3';
export const NUMPAD_4 = '4';
export const NUMPAD_5 = '5';
export const NUMPAD_6 = '6';
export const NUMPAD_7 = '7';
export const NUMPAD_8 = '8';
export const NUMPAD_9 = '9';
export const PERIOD = '.';
export const SUPR = 'Delete';
export const TAB = 'Tab';
export const V = 'v';
export const X = 'x';
//# sourceMappingURL=keys.js.map